var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// video modal
var $videoModal = $('#video-modal.modal');

// YT player object
var player;
var currVideoId;
var ytVars;
var ytLang;
var ytLoadPolicy = 1;

ytLang = $("body").attr("class").substring(0, 2);
if (ytLang == "en") {
    ytLoadPolicy = 0;
}
ytVars = {
    modestbranding: 1,
    cc_load_policy: ytLoadPolicy,
    cc_lang_pref: ytLang,
    hl: ytLang,
};

function onYouTubeIframeAPIReady() {
}

function onPlayerReady(event) {

}

function onPlayerStateChange(event) {
    var title = event.target.getVideoData().title;
    var category = 'Video';
    var label = 'Video: ' + title + ' - URL: ' + currHref;



    if (event.data == YT.PlayerState.PAUSED) {
        ga('send', 'event', category + ' - Paused', title, label);
    }
    if (event.data == YT.PlayerState.PLAYING) {
        ga('send', 'event', category + ' - Play', title, label);
    }
    if (event.data == YT.PlayerState.ENDED) {
        ga('send', 'event', category + ' - Watch to End', title, label);
    }
    //if (event.data == YT.PlayerState.BUFFERING) {
    //    ga('send', 'event', category + ' - Buffering', title, label);
    //}
    if (event.data == YT.PlayerState.CUED) {
        ga('send', 'event', category + ' - Cued', title, label);
    }
}

function playVideo(id) {
    currVideoId = id;
    if (player) {
        player.loadVideoById(id, 0);
    } else {
        // create player to be used for all videos
        player = new YT.Player('modal-player', {
            playerVars: ytVars,
            videoId: id,
            events: {
                onReady: function () {
                    player.loadVideoById(currVideoId);
                },
                onStateChange: onPlayerStateChange
            }
        });
    }
}

function loadVideo(videoId) {
    $videoModal.modal();
    playVideo(videoId);
}

function pauseVideo() {
    player.pauseVideo();
}

$('document').ready(function () {
    // get video ID
    $(document.body).on('click', 'a.is-video', function (e) {
        e.preventDefault();
        var videoId = $(this).attr('data-video-id');
        loadVideo(videoId);
    });

    // capture modal close and pause video
    $videoModal.on('hidden.bs.modal', function (e) {
        pauseVideo();
    });

    // load inline video on load
    var $worldMapModal = $('.world-map-modal.modal');
    $worldMapModal.on('shown.bs.modal', function (e) {
        var target = $worldMapModal.find("[data-youtubeid]");
        if (target.length) {
            player = new YT.Player("world-map-player", {
                playerVars: ytVars,
                videoId: target.attr("data-youtubeid"),
                events: {
                    onReady: function () {
                    },
                    onStateChange: onPlayerStateChange
                }
            });
        }
    });
    //pauseVideo();
    $worldMapModal.on('hidden.bs.modal', function (e) {
        $("#world-map-player").replaceWith('<div id="world-map-player"></div>');
    });
});